import { ComponentProps, forwardRef } from "react";
import { Tabs as BaseTab } from "@base-ui-components/react/tabs";
import {
  tabIndicatorClasses,
  tabListClasses,
  TabListVariants,
} from "./TabList.style";
import { useMediaQuery } from "@/hooks";
import Select from "@/Select";
import { useTabContext } from "@/Tabs/TabContext";

export type TabsListProps = TabListVariants &
  ComponentProps<typeof BaseTab.List> & {
    value?: any;
    onValueChange?: (value: any) => void;
  } & {
    name?: string;
  };

const TabList = forwardRef<HTMLDivElement, TabsListProps>((props, ref) => {
  const { children, className, value, onValueChange, name, ...rest } = props;
  const { defaultValue, value: tabValue } = useTabContext();
  const isMobile = useMediaQuery("sm");
  return (
    <BaseTab.List
      className={tabListClasses({
        className: typeof className === "string" ? className : "",
      })}
      ref={ref}
      {...rest}
      render={({ className: tbClasses, ...others }) =>
        isMobile ? (
          <Select
            defaultValue={defaultValue}
            value={tabValue}
            {...others}
            name={name}
            noLabel={name !== undefined}
          />
        ) : (
          <div {...others} className={tbClasses} />
        )
      }
    >
      {children}
      <BaseTab.Indicator className={tabIndicatorClasses({})} />
    </BaseTab.List>
  );
});

TabList.displayName = "TabList";

export default TabList;
